export default "__VITE_ASSET__CpeDC2rt__"